/**
 * 字段预设下拉框：单列列表
 * 焦点进入 textarea 时由父组件控制显示；点击项目填入并关闭
 *
 * 关键：容器 onMouseDown preventDefault → 点击下拉项时 textarea 不会失焦
 * 否则 blur 会先于 click 触发导致下拉先关闭、点击不生效
 */

import type { CSSProperties } from 'react'

interface Props {
  items: string[]
  value: string
  onSelect: (next: string) => void
}

const containerStyle: CSSProperties = {
  background: '#0b1120',
  border: '1px solid #334155',
  borderRadius: 6,
  boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
  marginTop: 4,
  maxHeight: 180,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
}

const itemBase: CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '6px 10px',
  border: 'none',
  textAlign: 'left',
  cursor: 'pointer',
  fontSize: 12,
  fontFamily: 'inherit',
  lineHeight: 1.5,
  background: 'transparent',
  color: '#cbd5e1',
}

export function PresetDropdown({ items, value, onSelect }: Props) {
  const trimmed = value.trim()
  return (
    <div
      className="nodrag"
      style={containerStyle}
      onMouseDown={(e) => e.preventDefault()}
    >
      {items.map((item) => {
        const selected = trimmed === item
        return (
          <button
            key={item}
            type="button"
            onClick={() => onSelect(item)}
            onMouseEnter={(e) => {
              if (!selected) e.currentTarget.style.background = 'rgba(139,92,246,0.15)'
            }}
            onMouseLeave={(e) => {
              if (!selected) e.currentTarget.style.background = 'transparent'
            }}
            style={{
              ...itemBase,
              background: selected ? 'rgba(99,102,241,0.30)' : 'transparent',
              color: selected ? '#fff' : '#cbd5e1',
            }}
          >
            {item}
          </button>
        )
      })}
    </div>
  )
}
